import { render, staticRenderFns } from "./opt.vue?vue&type=template&id=002a034c&scoped=true"
import script from "./opt.vue?vue&type=script&lang=js"
export * from "./opt.vue?vue&type=script&lang=js"
import style0 from "./opt.vue?vue&type=style&index=0&id=002a034c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a034c",
  null
  
)

export default component.exports